import React from 'react';
import { SideBySideMain } from './index.style'
import PropTypes from 'prop-types';
import Container from '@components/Container';
import Grid from '@components/Grid';
import GridItem from '@components/GridItem';
import RichText from '@components/RichText';
import { Heading2Serif } from '@components/TextStyles';
import Spacer from '@components/Spacer';
import { GatsbyImage } from 'gatsby-plugin-image';

const SideBySide = ({data, bgColor, tColor}) => {

    const {title, featuredTitle, featuredContent, featuredImage} = data;
    return (
        <SideBySideMain bgColor={bgColor} tColor={tColor}>
            <Spacer size={[60, 160]}/>
            <Container>
                <Grid columnCount={12}>
                    <GridItem tabletL={7}>
                        {featuredTitle && 
                            <RichText
                                content={featuredTitle}
                                as="h2"
                                paragraphSize="heading2Serif"
                            />
                        }
                        <Spacer size={[30, 55]}/>
                        <RichText
                            content={featuredContent}
                            paragraphSize="small"
                            className="content"
                        />
                    </GridItem>
                    <GridItem tabletL={5} tabletLStart={8} className="imageCol">
                        <Spacer size={[40, 140]}/>
                        <GatsbyImage 
                            image={featuredImage.gatsbyImageData}
                            alt={featuredImage.description}
                        />
                    </GridItem>
                </Grid>
            </Container>
            <Spacer size={[60, 140]}/>
        </SideBySideMain>
    );
};

SideBySide.propTypes = {
    title: PropTypes.string,
    text: PropTypes.object,
    image: PropTypes.object,
};

export default SideBySide;